// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-table-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: var(--bg-central);
}

/* Base table: FORCE FIXED PIXELS */
.dynamic-table {
  /* CRITICAL: separate + 0 spacing removes the 10-20px gaps */
  border-collapse: separate !important;
  border-spacing: 0 !important;
  table-layout: fixed !important; 
  width: max-content !important; 
}

.dynamic-table th,
.dynamic-table td {
  /* LOCK WIDTHS TO JS PIXELS */
  width: var(--col-width) !important;
  min-width: var(--col-width) !important;
  max-width: var(--col-width) !important;

  border-right: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
  /* padding: 8px 5px; */
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box !important;
  background-color: var(--bg-central); /* Opaque for sticky */
}

/* =========================
   THEAD (Dark/Light Sync)
   ========================= */
.dynamic-table thead th {
  position: sticky;
  top: 0;
  background-color: var(--bg-panel) !important;
  color: var(--text-main);
  z-index: 50;
}

/* Filter Row: Sits below labels */
.dynamic-table thead tr:nth-child(2) th {
  top: 40px; 
  z-index: 49;
}

/* =========================
   Sticky Columns & Intersections
   ========================= */
.sticky-col {
  position: sticky !important;
  left: var(--col-left) !important;
  z-index: 30;
  background-color: var(--bg-panel) !important;
  padding: 4px 6px !important; 
}

/* Top priority: Header + Sticky Column */
.dynamic-table thead th.sticky-col {
  z-index: 60;
}

/* =========================
   Interactive Elements
   ========================= */
.dynamic-table tbody tr:hover td {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.selected-row td {
  background-color: rgba(61, 90, 254, 0.2) !important; /* Glow Blue */
  border-top: 1px solid var(--accent);
  border-bottom: 1px solid var(--accent);
}

/* --- THE RESIZER HANDLE --- */
.col-resizer {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  cursor: col-resize;
  z-index: 100;
  background: transparent;
}

.col-resizer:hover {
  background-color: var(--accent) !important;
  box-shadow: 0 0 8px var(--accent);
}

/* --- INPUTS & SELECTS (CYBER DARK) --- */
.header-filter-input, .header-filter-select, .cell-input, .cell-select {
  width: 100%;
  padding: 4px 6px;
  font-size: 11px;
  background-color: #1a1a1a !important;
  color: var(--text-main);
  border: 1px solid #444;
  border-radius: 4px;
  outline: none;
  box-sizing: border-box;
}

.header-filter-input:focus {
  border-color: var(--accent);
}
/* 1. THE VIEWPORT (The Scrollable Box) */
.dynamic-table-container {
  flex: 1 1;             /* Grow to fill all space until the Right panel */
  width: 100%;
  height: 100%;
  overflow: auto;      /* Show scrollbars only when needed */
  background-color: var(--bg-app);
  display: block;      /* Ensure it behaves as a block container */
}

/* 2. THE TABLE (The Stretching Logic) */
.dynamic-table {
  table-layout: fixed !important;
  border-collapse: separate !important;
  border-spacing: 0;

  /* THE MAGIC COMBO: */
  width: max-content !important; /* Allows it to grow past the screen */
  min-width: 100% !important;    /* Forces it to be AT LEAST as wide as the gap */
}

/* 3. THE LAST COLUMN FIX */
/* To prevent the last column from looking "chopped off" */
.dynamic-table th:last-child, 
.dynamic-table td:last-child {
  border-right: none; 
}

/* --- 1. THE CELLS (TH & TD) --- */
.dynamic-table th,
.dynamic-table td {
  /* Increase Font: 11px -> 13px */
  font-size: 13px !important; 
  font-weight: 500;
 
  /* Decrease Padding: 8px -> 4px (Vertical) */
  /* padding: 1px 6px !important;  */
  
  /* Hard Lock Height: Slimmer rows */
  height: 28px !important; 
  
  line-height: 1.2;
  box-sizing: border-box;
}

/* --- 2. THE INPUTS & SELECTS --- */
.cell-input, 
.cell-select, 
.header-filter-input {
  /* Match the new 13px font */
  font-size: 13px !important;

  height: 100%;
  /* padding: 2px 4px !important; Minimal padding inside the input */
  outline: none !important;      /* Kill the blue box */
  margin: 0;
  border: none;
  background: transparent;
}

/* --- 3. THE HEADER LABELS --- */
.dynamic-table thead th {
  font-size: 12px; /* Headers can stay slightly smaller/bolder */
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 700;
  height: 32px !important; /* Slightly taller than data rows */
}

/* --- 4. ACTION BUTTONS (Icon Buttons) --- */
.cell-icon-btn {
  padding: 1px !important;
  font-size: 14px; /* Icons can be slightly larger for visibility */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Ensure the input stays clean while typing */
.cell-input:focus, .cell-select:focus {
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.selected-row .sticky-col {
   /* Ensures the blue line continues over the sticky part */
   box-shadow: inset 0 1px 0 0 var(--accent) !important; 
   background-color: rgba(188, 19, 254, 0.15) !important; 
}








`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/Central/CentralUnitViewPort/DynamicTable1.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mCAAmC;AACrC;;AAEA,mCAAmC;AACnC;EACE,4DAA4D;EAC5D,oCAAoC;EACpC,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,kCAAkC;EAClC,sCAAsC;EACtC,sCAAsC;;EAEtC,2CAA2C;EAC3C,4CAA4C;EAC5C,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,mCAAmC,EAAE,sBAAsB;AAC7D;;AAEA;;8BAE8B;AAC9B;EACE,gBAAgB;EAChB,MAAM;EACN,4CAA4C;EAC5C,uBAAuB;EACvB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,SAAS;EACT,WAAW;AACb;;AAEA;;8BAE8B;AAC9B;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,WAAW;EACX,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,WAAW;AACb;;AAEA;;8BAE8B;AAC9B;EACE,sDAAsD;AACxD;;AAEA;EACE,mDAAmD,EAAE,cAAc;EACnE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;AACA,yCAAyC;AACzC;EACE,SAAO,cAAc,iDAAiD;EACtE,WAAW;EACX,YAAY;EACZ,cAAc,OAAO,qCAAqC;EAC1D,+BAA+B;EAC/B,cAAc,OAAO,2CAA2C;AAClE;;AAEA,wCAAwC;AACxC;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iBAAiB;;EAEjB,qBAAqB;EACrB,6BAA6B,EAAE,sCAAsC;EACrE,0BAA0B,KAAK,gDAAgD;AACjF;;AAEA,2BAA2B;AAC3B,0DAA0D;AAC1D;;EAEE,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;;EAEE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;;EAEhB,4CAA4C;EAC5C,kCAAkC;;EAElC,mCAAmC;EACnC,uBAAuB;;EAEvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;;;EAGE,4BAA4B;EAC5B,0BAA0B;;EAE1B,YAAY;EACZ,kEAAkE;EAClE,wBAAwB,OAAO,sBAAsB;EACrD,SAAS;EACT,YAAY;EACZ,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,eAAe,EAAE,6CAA6C;EAC9D,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB,EAAE,mCAAmC;AAC9D;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,eAAe,EAAE,gDAAgD;EACjE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;GACG,yDAAyD;GACzD,oDAAoD;GACpD,qDAAqD;AACxD","sourcesContent":[".dynamic-table-container {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: var(--bg-central);\n}\n\n/* Base table: FORCE FIXED PIXELS */\n.dynamic-table {\n  /* CRITICAL: separate + 0 spacing removes the 10-20px gaps */\n  border-collapse: separate !important;\n  border-spacing: 0 !important;\n  table-layout: fixed !important; \n  width: max-content !important; \n}\n\n.dynamic-table th,\n.dynamic-table td {\n  /* LOCK WIDTHS TO JS PIXELS */\n  width: var(--col-width) !important;\n  min-width: var(--col-width) !important;\n  max-width: var(--col-width) !important;\n\n  border-right: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n  /* padding: 8px 5px; */\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-sizing: border-box !important;\n  background-color: var(--bg-central); /* Opaque for sticky */\n}\n\n/* =========================\n   THEAD (Dark/Light Sync)\n   ========================= */\n.dynamic-table thead th {\n  position: sticky;\n  top: 0;\n  background-color: var(--bg-panel) !important;\n  color: var(--text-main);\n  z-index: 50;\n}\n\n/* Filter Row: Sits below labels */\n.dynamic-table thead tr:nth-child(2) th {\n  top: 40px; \n  z-index: 49;\n}\n\n/* =========================\n   Sticky Columns & Intersections\n   ========================= */\n.sticky-col {\n  position: sticky !important;\n  left: var(--col-left) !important;\n  z-index: 30;\n  background-color: var(--bg-panel) !important;\n  padding: 4px 6px !important; \n}\n\n/* Top priority: Header + Sticky Column */\n.dynamic-table thead th.sticky-col {\n  z-index: 60;\n}\n\n/* =========================\n   Interactive Elements\n   ========================= */\n.dynamic-table tbody tr:hover td {\n  background-color: rgba(255, 255, 255, 0.05) !important;\n}\n\n.selected-row td {\n  background-color: rgba(61, 90, 254, 0.2) !important; /* Glow Blue */\n  border-top: 1px solid var(--accent);\n  border-bottom: 1px solid var(--accent);\n}\n\n/* --- THE RESIZER HANDLE --- */\n.col-resizer {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 6px;\n  cursor: col-resize;\n  z-index: 100;\n  background: transparent;\n}\n\n.col-resizer:hover {\n  background-color: var(--accent) !important;\n  box-shadow: 0 0 8px var(--accent);\n}\n\n/* --- INPUTS & SELECTS (CYBER DARK) --- */\n.header-filter-input, .header-filter-select, .cell-input, .cell-select {\n  width: 100%;\n  padding: 4px 6px;\n  font-size: 11px;\n  background-color: #1a1a1a !important;\n  color: var(--text-main);\n  border: 1px solid #444;\n  border-radius: 4px;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.header-filter-input:focus {\n  border-color: var(--accent);\n}\n/* 1. THE VIEWPORT (The Scrollable Box) */\n.dynamic-table-container {\n  flex: 1;             /* Grow to fill all space until the Right panel */\n  width: 100%;\n  height: 100%;\n  overflow: auto;      /* Show scrollbars only when needed */\n  background-color: var(--bg-app);\n  display: block;      /* Ensure it behaves as a block container */\n}\n\n/* 2. THE TABLE (The Stretching Logic) */\n.dynamic-table {\n  table-layout: fixed !important;\n  border-collapse: separate !important;\n  border-spacing: 0;\n\n  /* THE MAGIC COMBO: */\n  width: max-content !important; /* Allows it to grow past the screen */\n  min-width: 100% !important;    /* Forces it to be AT LEAST as wide as the gap */\n}\n\n/* 3. THE LAST COLUMN FIX */\n/* To prevent the last column from looking \"chopped off\" */\n.dynamic-table th:last-child, \n.dynamic-table td:last-child {\n  border-right: none; \n}\n\n/* --- 1. THE CELLS (TH & TD) --- */\n.dynamic-table th,\n.dynamic-table td {\n  /* Increase Font: 11px -> 13px */\n  font-size: 13px !important; \n  font-weight: 500;\n \n  /* Decrease Padding: 8px -> 4px (Vertical) */\n  /* padding: 1px 6px !important;  */\n  \n  /* Hard Lock Height: Slimmer rows */\n  height: 28px !important; \n  \n  line-height: 1.2;\n  box-sizing: border-box;\n}\n\n/* --- 2. THE INPUTS & SELECTS --- */\n.cell-input, \n.cell-select, \n.header-filter-input {\n  /* Match the new 13px font */\n  font-size: 13px !important;\n\n  height: 100%;\n  /* padding: 2px 4px !important; Minimal padding inside the input */\n  outline: none !important;      /* Kill the blue box */\n  margin: 0;\n  border: none;\n  background: transparent;\n}\n\n/* --- 3. THE HEADER LABELS --- */\n.dynamic-table thead th {\n  font-size: 12px; /* Headers can stay slightly smaller/bolder */\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 700;\n  height: 32px !important; /* Slightly taller than data rows */\n}\n\n/* --- 4. ACTION BUTTONS (Icon Buttons) --- */\n.cell-icon-btn {\n  padding: 1px !important;\n  font-size: 14px; /* Icons can be slightly larger for visibility */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Ensure the input stays clean while typing */\n.cell-input:focus, .cell-select:focus {\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n.selected-row .sticky-col {\n   /* Ensures the blue line continues over the sticky part */\n   box-shadow: inset 0 1px 0 0 var(--accent) !important; \n   background-color: rgba(188, 19, 254, 0.15) !important; \n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
